import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { AgentRotationViewRoutes } from '../../../routes/HomeRoutes/AgentRotationLogRoutes';

export const AgentRotaionLogLayout = () => (
  <SwitchRoute routes={AgentRotationViewRoutes} />
);
